module.exports = __webpack_public_path__ + "img/notepad-03.6309b480.png";